import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss']
})
export class PdfPreviewComponent implements OnInit {
  @Input() resourceUrl: string | undefined = undefined;
  @Input() isPdfPreviewModalShow: boolean = false;
  @Output() showPdfPreviewModal = new EventEmitter<boolean>();

  readOnlyFileUrl: string | undefined | unknown = undefined;
  tempBlob: Blob | null = null;
  options = {};
  spinnerOn: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.spinnerOn = true;
    this.options =
    {
      url: this.resourceUrl || '',
    };
  }

  onPdfLoadComplete(): void {
    this.spinnerOn = false;
  }

  onPdfLoadError(error: any): void {
    this.spinnerOn = false;
  }

  closePdfPreviewModal(): void {
    this.spinnerOn = false;
    this.isPdfPreviewModalShow = false;
    this.showPdfPreviewModal.emit(false);
  }
  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === 'p' ||
      (event.metaKey && event.key.toLowerCase() === 'p') ||
      event.key === 'PrintScreen') {
      event.preventDefault();
    }
  }
}
